<script>
import CasesCommonHeadMobile from "@/components/mobile/案例/CasesCommonHeadMobile.vue";
import NextCaseButtonMobile from "@/components/mobile/案例/NextCaseButtonMobile.vue";

export default {
  name: "MobileJiaxing",
  components: {NextCaseButtonMobile, CasesCommonHeadMobile}
}
</script>

<template>
  <div class="MobileJiaxing">
    <CasesCommonHeadMobile :use-pic="true" :picurl="require('@/assets/picture/案例/佳兴/移动端Banner.png')" :arrow-url="require('@/assets/anime/案例首页线条-黄绿色.mp4')" :title-color="'#1B8849'">
      <template #headerTitle>佳兴环保智慧管网运维平台</template>
      <template #headerSlogan>PC端界面设计｜APP界面设计</template>
      <template #title1>成果</template>
      <template #content1>佳兴环保智慧管网运维平台已成功落地并投入使用，该平台帮助佳兴团队的运维人员更好地管理和维护公司的管网设备。</template>
      <template #title2>背景</template>
      <template #content2>佳兴环保智慧管网运维平台在前一版本的平台开发和使用过程中，我们积累了宝贵的经验和反馈意见。通过与用户的交流和市场调研，我们将PC端和移动端的视觉做出了统一，将原本文字信息呈现的内容，用图表/插画和文字结合的形式来展示，让信息层级更加清晰。</template>
    </CasesCommonHeadMobile>
    <div class="JiaxingCustom">
      <div class="Container1">
        <div class="Top">
          <div class="Pic Pic1"></div>
        </div>
        <div class="Bottom">
          <div class="Pic Pic2"></div>
          <div class="Pic Pic3"></div>
        </div>
      </div>
      <div class="Container2">
        <div class="Content">
          <div class="Title3">统一<br>两个平台的视觉一致性</div>
          <div class="Text3">我们重点关注PC端和移动端的视觉设计，确保两个平台之间的一致性。通过统一视觉风格，用户无论使用哪个设备访问平台，都能够感受到一致的界面和操作方式，提高了用户的使用便利性。</div>
        </div>
        <div class="PicBox">
          <div class="Pic Pic4"></div>
          <div class="Pic Pic5"></div>
        </div>
      </div>
      <div class="Container3">
        <div class="Content">
          <div class="Title4">统一<br>两个平台的视觉一致性</div>
          <div class="Text4">我们重点关注PC端和移动端的视觉设计，确保两个平台之间的一致性。通过统一视觉风格，用户无论使用哪个设备访问平台，都能够感受到一致的界面和操作方式，提高了用户的使用便利性。</div>
        </div>
        <div class="PicBox">
          <div class="Pic Pic6"></div>
          <div class="Pic Pic7"></div>
        </div>
      </div>
      <div class="NextContainer">
        <router-link to="/mobileCase/case005"><NextCaseButtonMobile></NextCaseButtonMobile></router-link>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/global.scss" as global;

@mixin flex {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
@mixin picbox{
  border-radius: 12px;
  background: {
    repeat: no-repeat;
    size: cover;
    position: center;
  };
}
@mixin margin{
  margin-top: calc(32vw / 3.93);
  margin-bottom: calc(32vw / 3.93);
}
@mixin titleColor{
  color: #1B8849;
}

.Pic {
  @include picbox;
}
.MobileJiaxing {
  width: 100vw;
  height: auto;
  .JiaxingCustom {
    width: 100%;
    height: auto;
    padding-left: 4%;
    padding-right: 4%;
    @include flex;
    .Container1 {
      width: 100%;
      height: calc(364vw / 3.93);
      @include margin;
      @include flex;
      .Top {
        width: 100%;
        height: calc(176vw / 3.93);
        .Pic1 {
          width: 100%;
          height: 100%;
          background-image: url("@/assets/picture/案例/佳兴/移动端佳兴01.png");
        }
      }
      .Bottom {
        width: 100%;
        height: calc(172vw / 3.93);
        @include flex;
        flex-direction: row;
        .Pic {
          width: calc(172vw / 3.93);
          height: 100%;
        }
        .Pic2 {
          background-image: url("@/assets/picture/案例/佳兴/移动端佳兴02.png");
        }
        .Pic3 {
          background-image: url("@/assets/picture/案例/佳兴/移动端佳兴03.png");
        }
      }
    }
    .Container2 {
      width: 100%;
      height: calc(308vw / 3.93);
      @include margin;
      @include flex;
      .Content {
        width: 100%;
        min-height: calc(96vw / 3.93);
        @include flex;
        flex-direction: row;
        .Title3 {
          width: 40%;
          height: 100%;
          @include global.h4-vw-m;
          @include titleColor;
        }
        .Text3 {
          width: 50%;
          height: 100%;
          @include global.content-vw-m;
        }
      }
      .PicBox {
        width: 100%;
        height: calc(172vw / 3.93);
        @include flex;
        flex-direction: row;
        .Pic {
          width: calc(172vw / 3.93);
          height: 100%;
        }
        .Pic4 {
          background-image: url("@/assets/picture/案例/佳兴/移动端佳兴04.png");
        }
        .Pic5 {
          background-image: url("@/assets/picture/案例/佳兴/移动端佳兴05.png");
        }
      }
    }
    .Container3 {
      width: 100%;
      height: calc(526vw / 3.93);
      @include margin;
      @include flex;
      .Content {
        width: 100%;
        min-height: calc(96vw / 3.93);
        @include flex;
        flex-direction: row;
        .Title4 {
          width: 40%;
          height: 100%;
          @include global.h4-vw-m;
          @include titleColor;
        }
        .Text4 {
          width: 50%;
          height: 100%;
          @include global.content-vw-m;
        }
      }
      .PicBox {
        width: 100%;
        height: calc(390vw / 3.93);
        @include flex;
        .Pic {
          width: 100%;
          height: calc(175vw / 3.93);
        }
        .Pic6 {
          background-image: url("@/assets/picture/案例/佳兴/移动端佳兴06.png");
        }
        .Pic7 {
          background-image: url("@/assets/picture/案例/佳兴/移动端佳兴07.png");
        }
      }
    }
    .NextContainer {
      width: 100%;
      height: calc(44vw / 3.93);
      padding-left: 17%;
      padding-right: 17%;
      margin-top: calc(64vw / 3.93);
      margin-bottom: calc(64vw / 3.93);
    }
  }
}
</style>